import { render } from "./PremiumShop.vue?vue&type=template&id=b8ea6410"
import script from "./PremiumShop.vue?vue&type=script&lang=js"
export * from "./PremiumShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__